import type { GetStaticProps } from 'next';

import { ContentPage } from '@components/content-page/ContentPage';
import type { ContentPageProps } from '@components/content-page/ContentPage';
import { FRESHDESK_FORMS } from '@lib/constants';
import { loadContentPageProps } from '@lib/content-page/static-props';

const CONTENT_PAGE_SLUG = 'become-an-affiliate';

const AffiliatePage = (props: ContentPageProps) => (
  <ContentPage {...props}>
    <section className="mt-8" data-cy="affiliate-sign-up">
      <h3>Affiliate sign up</h3>
      <p className="mb-4">
        Ready to apply? Open our affiliate sign up form and a member of the team
        will be in touch.
      </p>
      <a
        href={FRESHDESK_FORMS.AFFILIATE_SIGN_UP}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex justify-center text-center rounded-lg transition-colors font-open-sans font-bold text-base border-2 border-transparent py-[7px] px-3 text-white bg-primary-600 hover:bg-primary-800 active:bg-neutral-800"
      >
        Apply to become an affiliate
      </a>
    </section>
  </ContentPage>
);

export const getStaticProps: GetStaticProps<ContentPageProps> = () =>
  loadContentPageProps(CONTENT_PAGE_SLUG);

export default AffiliatePage;
